/* src/app/modules/print-cards/components/cards/inflators/print-card-background-inflator/print-card-background-inflator.component.scss */
:host {
  display: flex;
  align-content: stretch;
  justify-content: stretch;
}
/*# sourceMappingURL=print-card-background-inflator.component.css.map */
